import {useEffect} from 'react';
import {preventDefaultEvent} from '../../../../../../common/shared/utils/preventDefaultEvent.function';
import {disableScroll} from '../util/disableScroll';
import {enableScroll} from '../util/enableScroll';

export function useDisableScrollOnFullscreen(isFullscreen: boolean) {
  useEffect(() => {
    if (isFullscreen) {
      disableScroll();
      // mobile에서 css로 스크롤을 막을 수 없는 경우가 있어 touchmove 이벤트를 막아준다.
      // 최신 브라우저는 passive 기본값을 true로 사용하는 경우가 많아서 preventDefault를 무시하므로 passive false값을 준다.
      window.addEventListener('touchmove', preventDefaultEvent, {
        passive: false,
      });
    } else {
      enableScroll();
      window.removeEventListener('touchmove', preventDefaultEvent);
    }
    return () => {
      window.removeEventListener('touchmove', preventDefaultEvent);
      enableScroll();
    };
  }, [isFullscreen]);
  return null;
}
